import { observable, action } from "mobx";

import userStore from "./user";

interface IStores {
	user: userStore;
	appStore: AppStore;
}
// Compact and organization other stores and main store in one place.
export class AppStore {
	public userStore: userStore;

	@observable public version = "";
	@observable public serverSide = false;

	constructor() {
		this.userStore = new userStore(this);
	}

	public store(name: keyof IStores) {
		return (this as Partial<IStores>)[name];
	}

	public stores(): IStores {
		return {
			appStore: this,
			user: this.userStore,
		};
	}

	@action
	setVersion(version: string) {
		this.version = version;
	}
}

const store: AppStore = new AppStore();

export default store;
